// @ts-ignore
const componentCssFiles = import.meta.glob("../themes/*/*/components/*/*.css", {
  eager: true,
  query: "?url&no-inline",
});

// @ts-ignore
const utilsCssFiles = import.meta.glob("../../../utils/src/components/*.css", {
  eager: true,
  query: "?url&no-inline",
});

const DEFAULT_RENDER_MEDIUM = "screen";

export function lazyCss(
  organizationSlug: string,
  projectSlug: string,
  defaultOrganizationSlug: string,
  defaultProjectSlug: string,
  renderMedium: "print" | "screen"
) {
  const foundForTheme: Record<string, true> = {};

  const foundMediumThemeFiles = Object.entries(componentCssFiles).filter(
    ([key]) => {
      const name = key.split("/").pop()!;
      if (
        key.startsWith(
          `../themes/${organizationSlug}/${projectSlug}/components/${renderMedium}`
        )
      ) {
        foundForTheme[name] = true;
        return true;
      }
      return false;
    }
  );

  const foundDefaultThemeMediumFiles = Object.entries(componentCssFiles).filter(
    ([key]) => {
      const name = key.split("/").pop()!;
      if (
        key.startsWith(
          `../themes/${defaultOrganizationSlug}/${defaultProjectSlug}/components/${renderMedium}`
        ) &&
        foundForTheme[name] === undefined
      ) {
        foundForTheme[name] = true;
        return true;
      }
      return false;
    }
  );

  const foundDefaultMediumThemeFiles = Object.entries(componentCssFiles).filter(
    ([key]) => {
      const name = key.split("/").pop()!;
      if (
        key.startsWith(
          `../themes/${organizationSlug}/${projectSlug}/components/${DEFAULT_RENDER_MEDIUM}`
        ) &&
        foundForTheme[name] === undefined
      ) {
        foundForTheme[name] = true;
        return true;
      }
      return false;
    }
  );

  const foundDefaultThemeDefaultMediumFiles = Object.entries(
    componentCssFiles
  ).filter(([key]) => {
    const name = key.split("/").pop()!;
    if (
      key.startsWith(
        `../themes/${defaultOrganizationSlug}/${defaultProjectSlug}/components/${DEFAULT_RENDER_MEDIUM}`
      ) &&
      foundForTheme[name] === undefined
    ) {
      foundForTheme[name] = true;
      return true;
    }
    return false;
  });

  const foundUtilsFiles = Object.entries(utilsCssFiles);

  const allCssFiles = [
    ...foundMediumThemeFiles,
    ...foundDefaultMediumThemeFiles,
    ...foundDefaultThemeMediumFiles,
    ...foundDefaultThemeDefaultMediumFiles,
    ...foundUtilsFiles,
  ];

  const cssFiles: { rel: string; id?: string; href: string }[] =
    allCssFiles.map(([_, value]) => ({
      rel: "stylesheet",
      href: (value as { default: string }).default,
    }));

  return cssFiles;
}
